<template>
  <div>
    <div v-for="(item, index) in dataList" :key="item.id || index" class="print-page">
      <table border="1" class="print-table" width="100%">
        <tr>
          <td class="print-title" colspan="6">MO票号：{{ item.moTicketCode }}</td>
        </tr>
        <tr>
          <td class="label-cell">工单号</td>
          <td>{{ item.wipEntityName }}</td>
          <td class="label-cell">成品物料名称</td>
          <td>{{ item.itemName }}</td>
          <td class="qr-cell" colspan="2" rowspan="2">
            <QrCode
              v-if="qrCodeText(item)"
              class="qr-code"
              :id="qrCodeId(item, index)"
              :text="qrCodeText(item)"
              width="130"
              height="130"
            />
          </td>
        </tr>
        <tr>
          <td class="label-cell">计划单号</td>
          <td>{{ item.orderNo }}</td>
          <td class="label-cell">工单套数</td>
          <td class="value-cell">{{ item.planQuantity }}</td>
        </tr>
        <tr>
          <td class="label-cell">成品规格描述</td>
          <td class="left-cell" colspan="5">{{ item.specificationDesc }}</td>
        </tr>
        <tr>
          <td class="label-cell">子工序</td>
          <td class="label-cell">派工人</td>
          <td class="label-cell" colspan="2">派工套数</td>
          <td class="label-cell" colspan="2">备注</td>
        </tr>
        <tr v-if="!item.lineList || item.lineList.length === 0">
          <td colspan="6">空</td>
        </tr>
        <tr v-for="(line, lineIndex) in item.lineList" :key="line.assignmentId || line.id || lineIndex">
          <td class="label-cell">{{ formatSubProcess(line) }}</td>
          <td>{{ formatPersonnel(line) }}</td>
          <td colspan="2">{{ line.assignedQuantity }}</td>
          <td colspan="2">{{ line.remark }}</td>
        </tr>
        <tr class="blank-row">
          <td></td>
          <td></td>
          <td colspan="2"></td>
          <td colspan="2"></td>
        </tr>
        <tr>
          <td class="label-cell">计划生产时间</td>
          <td>{{ printSchedulingDate(item) }}</td>
          <td class="label-cell">工单交期</td>
          <td>{{ formatDate(item.deliveryDate) }}</td>
          <td class="label-cell">完工时间</td>
          <td>{{ formatDate(item.completionDate) }}</td>
        </tr>
        <tr>
          <td class="label-cell">车间主管</td>
          <td>{{ item.workshopSupervisor }}</td>
          <td class="label-cell">收货人</td>
          <td>{{ item.receiver }}</td>
          <td colspan="2"></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import QrCode from '@/components/QrCode/index.vue'

export default {
  name: 'PrintSchedulingDetail',
  components: {
    QrCode
  },
  props: {
    idPrefix: {
      type: String,
      default: 'processSchedulingQrCode'
    }
  },
  data () {
    return {
      dataList: []
    }
  },
  methods: {
    show (dataList) {
      this.dataList = dataList
      this.$forceUpdate()
    },
    formatDate (date) {
      return date ? this.$moment(date).format('YYYY-MM-DD') : ''
    },
    printSchedulingDate (item) {
      if (item.scheduledStartDate) {
        return this.formatDate(item.scheduledStartDate)
      }
      const line = item.lineList && item.lineList[0]
      return line ? this.formatDate(line.schedulingDate) : ''
    },
    formatSubProcess (line) {
      return line.subProcessCodeName || line.subProcess || line.subProcessCode
    },
    formatPersonnel (line) {
      return line.assignedPersonnelName || line.assignedPersonnel
    },
    qrCodeText (item) {
      return item.moTicketCode || item.id
    },
    qrCodeId (item, index) {
      return `${this.idPrefix}_${item.id || index}`
    }
  }
}
</script>

<style scoped lang="less">
.print-page {
  font-family: "黑体", "微软雅黑", "宋体", serif;
  color: #000;
  page-break-after: always;
  padding: 6px;
  font-size: 16px;
}

.print-table {
  width: 100%;
  border: 2px solid #000;
  border-collapse: collapse;
  table-layout: fixed;
  text-align: center;
}

.print-table td {
  height: 52px;
  padding: 0 6px;
  word-break: break-all;
}

.print-title {
  height: 50px;
  font-weight: 600;
}

.label-cell {
  font-weight: 600;
}

.value-cell {
  text-align: left;
}

.left-cell {
  text-align: left;
}

.qr-cell {
  width: 120px;
  padding: 0;
}

.blank-row td {
  height: 52px;
}

/deep/.qr-code {
  margin: 2px 0;
  img {
    margin: auto;
  }
}
</style>
